module.exports = __webpack_public_path__ + "img/Sign up.879f0823.svg";